import React, { Component } from 'react';
import { Layout, Row, Col, Avatar } from 'antd';
import axios from 'axios';
import { closeWin } from './ip-client';
import './index.css';
import { devApiUrl, proApiUrl } from '../../utils/index'
const { Header } = Layout;

class Index extends Component {
  state = {
    userName: window.sessionStorage.getItem('userName') ? JSON.parse(window.sessionStorage.getItem('userName')) : '暂无姓名',
    appCode: window.sessionStorage.getItem('appCode') ? JSON.parse(window.sessionStorage.getItem('appCode')) : '',
  }
  // 记录应用登录日志
  addLogoutLog() {

  }
  //点击退出
  esc = () => {
    const { appCode } = this.state;
    //正常登陆而来
    let userCode = JSON.parse(sessionStorage.getItem('userCode'))
    let token = sessionStorage.getItem('token')
    axios({
      url: `${process.env.REACT_APP_ENV === "dev" ? devApiUrl : proApiUrl}/portal/log/appAccess/recordAppLogoutInfo/handbook/${userCode}`,
      headers: { "Content-Type": "application/json", "Authorization": token },
      method: "post",
    }).then(function (response) {
      console.log('日志记录成功', response)
    }).finally(() => {
      if (appCode) {
        //从门户窗口进来
        sessionStorage.clear();
        closeWin(appCode)
      } else {
        sessionStorage.clear();
        window.location.href = window.location.origin;
      }
    })

  }

  render() {
    return (<Header>
      <Row>
        <Col span={8}><h3 style={{ paddingLeft: '20px' }}>云豪集团公司《员工手册》</h3></Col>
        <Col span={4} offset={11} style={{ textAlign: 'right' }}>账户：{this.state.userName} (员工) </Col>
        <Col span={1} style={{ padding: '0 0 0 12px' }}>
          <Avatar icon="logout" style={{ background: '#000', cursor: 'pointer' }} onClick={this.esc} />
        </Col>
      </Row>
    </Header>)
  }
}


export default Index;


